<template>
    <div v-if="testimonialContent && isShown">
        <p class=" ut-text-lg ut-font-bold ut-mb-4">{{ testimonialContent.summary }}</p>
        <p class=" ut-text-base">{{ testimonialContent.quote}}</p>
        <div class="ut-flex ut-mt-4">
            <img :src="testimonialContent.customerImage" alt="Howard Profile" width="64px" height="64px"
                class=" ut-object-cover ut-rounded-full ut-w-16 ut-h-16 ut-overflow-hidden ut-ml-0 ut-mr-4" />
            <div class="ut-ml-0">
                <div class="ut-flex">
                    <svg-icon v-for="n in 5" :key="n" :icon="'icon-star'" :size="14" :addClass="'ut-text-Gnew'"
                        class="ut-mx-0"></svg-icon>
                </div>
                <p class=" ut-text-base ut-text-N400 ut-mt-1">{{ testimonialContent.customerName }} - Reviewed on
                    Trustpilot</p>
            </div>
        </div>
    </div>

</template>

<script>
import SvgIcon from './SvgIcon.vue';
export default {
    name: 'Testimonial',
    props: {
        step: {
            type: Number,
            required: true,
        },
        isShown: {
            type: Boolean,
            default: false,
        }
    },
    components: {
        SvgIcon,
    },
    data() {
        return {
            testimonialData: [
                {
                    "step": 6,
                    "summary": "Prompt. Friendly & Knowledgeable",
                    "quote": "The contact from OpenAgent was prompt, friendly & knowledgeable about the real estate agencies that cover the area of the property. Three agents contacted me within 24 hours.",
                    "customerName": "Howard",
                    "customerImage": require("@/assets/images/howard-profile-image.webp"),
                },
                {
                    "step": 7,
                    "summary": "Making Life Easier",
                    "quote": "Having a knowledgeable, interested person to find a selected successful local agent was a major benefit. They understood my needs and were helpful in contacting agents so I didn’t have to cold call. Follow up was also appreciated.",
                    "customerName": "Lyn",
                    "customerImage": require("@/assets/images/lyn-profile-image.webp"),
                }, {
                    "step": 8,
                    "summary": "Very Helpful",
                    "quote": "Very helpful, informative & no pressure experience. Also provided useful links to answer questions one might have when contemplating selling a property.",
                    "customerName": "Marianne",
                    "customerImage": require("@/assets/images/marianne-profile-image.webp"),
                }
            ]
        }
    },
    computed: {
        testimonialContent() {
            if (this.step) {
                return this.testimonialData.find((t) => t.step === this.step);
            }
            return null;
        }
    },
};
</script>

<style lang="scss" scoped>
</style>